import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import axiosInstance from '../../api/axiosConfig';
import AdminOverview      from './AdminOverview';
import EmployeeDashboard  from './EmployeeDashboard';
import CheckInWidget      from './CheckInWidget';
import AcknowledgementModal from '../../components/announcements/AcknowledgementModal';

// Roles that see the admin/HR management overview
// FIX: account-manager added — they manage payroll and employees
const ADMIN_ROLES = ['super-admin', 'admin', 'hr-manager', 'account-manager'];

const DashboardHome = () => {
    const { user } = useAuth();
    const isAdmin  = ADMIN_ROLES.includes(user?.role);

    // Attendance history for the employee dashboard widget
    // CheckInWidget handles today's check-in state independently
    const [history,        setHistory]        = useState([]);
    const [loadingHistory, setLoadingHistory] = useState(!isAdmin);

    // Stable fetch — depends only on isAdmin (primitive boolean), no function dep
    useEffect(() => {
        if (isAdmin) return;
        let cancelled = false;
        setLoadingHistory(true);
        axiosInstance.get('/attendance/history')
            .then(res => {
                if (!cancelled && res.data.success)
                    setHistory(res.data.data?.records || res.data.data || []);
            })
            .catch(() => {})
            .finally(() => { if (!cancelled) setLoadingHistory(false); });
        return () => { cancelled = true; };
    }, [isAdmin]);

    const fetchAttendanceHistory = () => {
        if (isAdmin) return;
        axiosInstance.get('/attendance/history')
            .then(res => {
                if (res.data.success)
                    setHistory(res.data.data?.records || res.data.data || []);
            })
            .catch(() => {});
    };

    return (
        <div className="dashboard-content">
            {/* Announcement acknowledgement popup */}
            <AcknowledgementModal />

            {/* Check-in widget — shared with Attendance page, always shows real state */}
            <CheckInWidget compact={false} />

            {/* Main dashboard view — admin overview or employee self-service */}
            {isAdmin
                ? <AdminOverview user={user} />
                : <EmployeeDashboard
                    user={user}
                    history={history}
                    loadingHistory={loadingHistory}
                    refreshHistory={fetchAttendanceHistory}
                    hideCheckIn={true}
                  />
            }
        </div>
    );
};

export default DashboardHome;
